import { useEffect, useState } from 'react';

/**
 * Compte à rebours « 26 j · 03 h 56 » de l'écran d'accueil.
 *
 * Rafraîchi à la minute et non à la seconde : afficher les secondes ferait tourner un
 * `setInterval` et un rendu React chaque seconde sur un écran que les membres laissent
 * ouvert pendant toute une séance, pour une information que personne ne lit à la seconde.
 */
export function useCountdown(target: string): string | null {
  const [label, setLabel] = useState(() => format(target));

  useEffect(() => {
    setLabel(format(target));
    const timer = setInterval(() => setLabel(format(target)), 60_000);
    return () => clearInterval(timer);
  }, [target]);

  return label;
}

function format(target: string): string | null {
  const ms = new Date(target).getTime() - Date.now();
  if (Number.isNaN(ms) || ms <= 0) return null;

  const totalMinutes = Math.floor(ms / 60_000);
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  const pad = (value: number) => String(value).padStart(2, '0');
  if (days > 0) return `${days} j · ${pad(hours)} h ${pad(minutes)}`;
  if (hours > 0) return `${pad(hours)} h ${pad(minutes)}`;
  return `${minutes} min`;
}
